/* global fbq */
/* global gtag */

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { customerDetailsApiCall, updateCustomerDetails, updateJourneyEvents } from '../../CustomerJourneyDetails/CustomerJourneyDetails';
import MobileNav from '../../component/MobileNav';
import { Link } from 'react-router-dom';
import ConnectUs from '../../component/ConnectUs';
import { Helmet } from 'react-helmet';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@500;600&display=swap');

  .ty-page * { box-sizing: border-box; margin: 0; padding: 0; }

  .ty-page {
    min-height: 100vh;
    background: #eaf1fd;
    font-family: 'Sora', sans-serif;
    display: flex;
    flex-direction: column;
    padding-bottom: 80px;
    margin-top: 55px;
  }

  /* ── TOP NAV ── */
  .ty-nav {
    padding: 1.5rem 3rem;
    display: flex; align-items: center; gap: 10px;
    flex-shrink: 0;
  }
  .ty-nav-dot {
    width: 34px; height: 34px; background: #F97316;
    border-radius: 10px; display: flex; align-items: center; justify-content: center;
  }
  .ty-nav-dot svg { width: 18px; height: 18px; fill: none; stroke: #fff; stroke-width: 2.2; stroke-linecap: round; }
  .ty-nav-name { font-size: 16px; font-weight: 600; color: #0f1c2e; letter-spacing: -0.2px; }

  /* ── MAIN ── */
  .ty-main {
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 2rem 1.5rem 3rem;
  }

  .ty-container {
    width: 100%;
    max-width: 640px;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }

  /* ── SUCCESS CARD ── */
  .ty-hero-card {
    background: #0f1c2e;
    border-radius: 24px;
    padding: 2.5rem 2.5rem 2rem;
    position: relative;
    overflow: hidden;
    text-align: center;
  }
  .ty-hero-blob1 {
    position: absolute; width: 260px; height: 260px; border-radius: 50%;
    background: radial-gradient(circle, rgba(55,138,221,0.2) 0%, transparent 70%);
    top: -80px; right: -60px; pointer-events: none;
  }
  .ty-hero-blob2 {
    position: absolute; width: 200px; height: 200px; border-radius: 50%;
    background: radial-gradient(circle, rgba(249,115,22,0.15) 0%, transparent 70%);
    bottom: -40px; left: -40px; pointer-events: none;
  }
  .ty-hero-grid {
    position: absolute; inset: 0;
    background-image:
      linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
    background-size: 40px 40px; pointer-events: none;
  }
  .ty-hero-inner { position: relative; z-index: 1; }

  /* SUCCESS RING */
  .ty-success-ring {
    width: 72px; height: 72px; border-radius: 50%;
    background: rgba(52,211,153,0.15);
    border: 2px solid rgba(52,211,153,0.5);
    display: flex; align-items: center; justify-content: center;
    margin: 0 auto 1.25rem;
    animation: ty-pop 0.5s cubic-bezier(0.34,1.56,0.64,1) both;
  }
  .ty-success-ring svg { width: 34px; height: 34px; fill: none; stroke: #34d399; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
  @keyframes ty-pop {
    from { transform: scale(0.5); opacity: 0; }
    to   { transform: scale(1);   opacity: 1; }
  }

  .ty-hero-tag {
    display: inline-flex; align-items: center; gap: 5px;
    background: rgba(52,211,153,0.15); border: 1px solid rgba(52,211,153,0.3);
    border-radius: 20px; padding: 4px 12px;
    color: #34d399; font-size: 11.5px; font-weight: 600;
    margin-bottom: 1rem;
  }
  .ty-hero-tag::before { content: '●'; font-size: 7px; animation: ty-blink 1.4s ease infinite; }
  @keyframes ty-blink { 0%,100% { opacity:1; } 50% { opacity:0.3; } }

  .ty-hero-title {
    font-size: 26px; font-weight: 700; color: #fff;
    letter-spacing: -0.7px; line-height: 1.2; margin-bottom: 10px;
  }
  .ty-hero-title span { color: #F97316; }
  .ty-hero-sub { font-size: 13.5px; color: rgba(255,255,255,0.5); line-height: 1.65; font-weight: 300; }

  /* REF NUMBER */
  .ty-ref-wrap {
    margin-top: 1.5rem;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 14px; padding: 14px 18px;
    display: flex; align-items: center; justify-content: space-between; gap: 12px;
  }
  .ty-ref-label { font-size: 11px; color: rgba(255,255,255,0.45); font-weight: 500; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px; }
  .ty-ref-value { font-family: 'JetBrains Mono', monospace; font-size: 18px; font-weight: 600; color: #F97316; letter-spacing: 1px; }
  .ty-ref-icon {
    width: 38px; height: 38px; border-radius: 10px;
    background: rgba(249,115,22,0.15);
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .ty-ref-icon svg { width: 18px; height: 18px; fill: none; stroke: #F97316; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }

  /* ── STEPS CARD ── */
  .ty-white-card {
    background: #fff;
    border-radius: 20px;
    padding: 1.75rem 2rem;
    box-shadow: 0 4px 24px rgba(15,28,46,0.07);
    border: 1px solid rgba(255,255,255,0.8);
  }
  .ty-card-title {
    font-size: 13px; font-weight: 600; color: #0f1c2e;
    margin-bottom: 1rem; display: flex; align-items: center; gap: 8px;
  }
  .ty-card-title::after { content: ''; flex: 1; height: 1px; background: #e8eef7; }

  .ty-steps { display: flex; flex-direction: column; gap: 10px; }
  .ty-step {
    display: flex; align-items: center; gap: 12px;
    padding: 12px 14px;
    background: #f7f9fc; border-radius: 12px;
    border: 1px solid #e8eef7;
  }
  .ty-step-dot {
    width: 30px; height: 30px; border-radius: 8px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .ty-step-dot.blue { background: rgba(55,138,221,0.12); }
  .ty-step-dot.orange { background: rgba(249,115,22,0.12); }
  .ty-step-dot.green { background: rgba(52,211,153,0.12); }
  .ty-step-dot svg { width: 15px; height: 15px; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
  .ty-step-dot.blue svg { stroke: #378ADD; }
  .ty-step-dot.orange svg { stroke: #F97316; }
  .ty-step-dot.green svg { stroke: #34d399; }
  .ty-step-text { font-size: 13px; color: #2d3748; font-weight: 500; }
  .ty-step-sub { font-size: 11.5px; color: #9aaabb; margin-top: 1px; }

  /* ── EKYC BUTTON ── */
  .ty-ekyc-btn {
    display: flex; align-items: center; justify-content: center; gap: 9px;
    width: 100%; padding: 14px 20px;
    background: #F97316; color: #fff;
    border-radius: 14px;
    font-family: 'Sora', sans-serif;
    font-size: 15px; font-weight: 600;
    text-decoration: none;
    box-shadow: 0 4px 18px rgba(249,115,22,0.32);
    transition: background 0.18s, transform 0.1s, box-shadow 0.18s;
  }
  .ty-ekyc-btn:hover {
    background: #ea6a0a;
    box-shadow: 0 6px 24px rgba(249,115,22,0.42);
    transform: translateY(-1px);
    color: #fff; text-decoration: none;
  }
  .ty-ekyc-btn svg { width: 17px; height: 17px; fill: none; stroke: #fff; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }

  /* ── CONNECT CARD ── */
  .ty-connect-card {
    background: #fff; border-radius: 20px;
    padding: 1.75rem 2rem;
    box-shadow: 0 4px 24px rgba(15,28,46,0.07);
    border: 1px solid rgba(255,255,255,0.8);
  }
  .ty-connect-title {
    font-size: 13px; font-weight: 600; color: #0f1c2e;
    margin-bottom: 1rem; display: flex; align-items: center; gap: 8px;
  }
  .ty-connect-title::after { content: ''; flex: 1; height: 1px; background: #e8eef7; }
  .ty-connect-sub { font-size: 12.5px; color: #6b7a90; margin-bottom: 1rem; }

  /* TRUST */
  .ty-trust {
    display: flex; align-items: center; justify-content: center;
    gap: 6px; margin-top: 1rem;
    font-size: 11.5px; color: #9aaabb;
  }
  .ty-trust svg { width: 13px; height: 13px; }
  .ty-trust-sep { width: 3px; height: 3px; background: #c8d3e2; border-radius: 50%; margin: 0 2px; }

  /* CONFETTI DOTS */
  .ty-confetti { position: fixed; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 0; overflow: hidden; }
  .ty-dot {
    position: absolute; border-radius: 50%;
    animation: ty-fall linear infinite;
    opacity: 0;
  }
  @keyframes ty-fall {
    0%   { transform: translateY(-20px) rotate(0deg); opacity: 1; }
    100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
  }

  /* RESPONSIVE */
  @media (max-width: 640px) {
    .ty-nav { padding: 1.25rem 1.25rem; }
    .ty-main { padding: 1rem 1rem 3rem; }
    .ty-hero-card { padding: 2rem 1.5rem 1.75rem; }
    .ty-hero-title { font-size: 22px; }
    .ty-ref-value { font-size: 15px; }
    .ty-white-card, .ty-connect-card { padding: 1.5rem 1.25rem; }
    .ty-ref-wrap { flex-direction: column; text-align: center; }
  }
`;

// Icons
const IconBolt = () => <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>;
const IconCheck = () => <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>;
const IconHash = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="4" y1="9" x2="20" y2="9"/><line x1="4" y1="15" x2="20" y2="15"/><line x1="10" y1="3" x2="8" y2="21"/><line x1="16" y1="3" x2="14" y2="21"/></svg>;
const IconReview = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const IconClock = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IconBell = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>;
const IconArrow = () => <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>;
const IconLock = () => <svg viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>;

// Confetti blobs
const DOTS = [
  { color: '#F97316', size: 8,  left: '10%', delay: '0s',   dur: '3.2s' },
  { color: '#378ADD', size: 6,  left: '25%', delay: '0.4s', dur: '2.8s' },
  { color: '#34d399', size: 10, left: '40%', delay: '0.8s', dur: '3.5s' },
  { color: '#F97316', size: 7,  left: '55%', delay: '0.2s', dur: '3.0s' },
  { color: '#378ADD', size: 9,  left: '70%', delay: '1.0s', dur: '2.6s' },
  { color: '#34d399', size: 6,  left: '85%', delay: '0.6s', dur: '3.8s' },
  { color: '#F97316', size: 5,  left: '92%', delay: '1.2s', dur: '2.9s' },
];

export default function Thankyou() {
  const customerDetails = useSelector((state) => state?.customerJourneyDetails?.customerDetails);
  const dispatch = useDispatch();
  const [showConfetti, setShowConfetti] = useState(true);
 
  const params = { profileId: customerDetails?.profileId };

  async function fetchCustomerDetails() {
    if (params.profileId) {
      let { payload } = await dispatch(customerDetailsApiCall(params));
      if (payload?.data?.apiStatus == 1) {
        dispatch(updateCustomerDetails(payload?.data?.data?.customer_details));
        dispatch(updateJourneyEvents(payload?.data?.data?.screen_details));
      }
    }
  }

  useEffect(() => {
    fetchCustomerDetails();
    const t = setTimeout(() => setShowConfetti(false), 4000);
    return () => clearTimeout(t);
    
  }, []);

  return (
    <>
    <Helmet>
      <meta name="robots" content="noindex,follow"></meta>
    </Helmet>
      <style>{styles}</style>

      {/* Confetti */}
      {showConfetti && (
        <div className="ty-confetti" aria-hidden="true">
          {DOTS.map((d, i) => (
            <div
              key={i}
              className="ty-dot"
              style={{
                width: d.size, height: d.size,
                background: d.color,
                left: d.left, top: '-20px',
                animationDelay: d.delay,
                animationDuration: d.dur,
              }}
            />
          ))}
        </div>
      )}

      <div className="ty-page">
        

        <div className="ty-main">
          <div className="ty-container">

            {/* ── HERO CARD ── */}
            <div className="ty-hero-card">
              <div className="ty-hero-grid" />
              <div className="ty-hero-blob1" />
              <div className="ty-hero-blob2" />
              <div className="ty-hero-inner">

                <div className="ty-success-ring"><IconCheck /></div>

                <div className="ty-hero-tag">Application submitted</div>

                <h1 className="ty-hero-title">
                  You're all <span>done!</span>
                </h1>
                <p className="ty-hero-sub">
                  Great! We've received your loan application.<br />
                  Our team will review it and get in touch with you shortly.
                </p>

                {/* Reference Number */}
                {customerDetails?.leadReferenceNo && (
                  <div className="ty-ref-wrap">
                    <div>
                      <div className="ty-ref-label">Reference number</div>
                      <div className="ty-ref-value">{customerDetails.leadReferenceNo}</div>
                    </div>
                    <div className="ty-ref-icon"><IconHash /></div>
                  </div>
                )}
              </div>
            </div>

            {/* ── EKYC BUTTON (conditional) ── */}
            {customerDetails?.show_ekyc_btn_flag === 1 && (
              <Link
                to={customerDetails?.ekyc_url}
                target="_blank"
                className="ty-ekyc-btn"
              >
                <IconArrow />
                {customerDetails?.show_ekyc_btn_text || 'Complete e-KYC'}
              </Link>
            )}

            {/* ── WHAT HAPPENS NEXT ── */}
            <div className="ty-white-card">
              <div className="ty-card-title">What happens next</div>
              <div className="ty-steps">
                <div className="ty-step">
                  <div className="ty-step-dot blue"><IconReview /></div>
                  <div>
                    <div className="ty-step-text">Application review</div>
                    <div className="ty-step-sub">Our team carefully reviews your application</div>
                  </div>
                </div>
                <div className="ty-step">
                  <div className="ty-step-dot orange"><IconClock /></div>
                  <div>
                    <div className="ty-step-text">Quick processing</div>
                    <div className="ty-step-sub">Decisions are usually made within 24 hours</div>
                  </div>
                </div>
                <div className="ty-step">
                  <div className="ty-step-dot green"><IconBell /></div>
                  <div>
                    <div className="ty-step-text">You'll be notified</div>
                    <div className="ty-step-sub">We'll update you via SMS, call, or email</div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── CONNECT US ── */}
            <div className="ty-connect-card">
              <div className="ty-connect-title">Need help?</div>
              <p className="ty-connect-sub">Reach out to us anytime — we're happy to help.</p>
              <ConnectUs />
            </div>

            {/* TRUST */}
            <div className="ty-trust">
              <IconLock />
              256-bit SSL encrypted
              <span className="ty-trust-sep" />
              Your data is private
              <span className="ty-trust-sep" />
              RBI compliant
            </div>

          </div>
        </div>
      </div>

      <MobileNav />
    </>
  );
}